"use client";

import { useSyncExternalStore } from "react";
import {
  subscribeSolicitudes,
  getSolicitudesSnapshot,
  getSolicitudesServerSnapshot,
} from "@/lib/solicitudesStore";

/**
 * Devuelve las solicitudes más recientes (hasta el límite del listener
 * compartido, ver `solicitudesStore.ts`). Todos los componentes que llaman
 * a este hook comparten una única suscripción real a Firestore.
 */
export function useSolicitudes() {
  const state = useSyncExternalStore(
    subscribeSolicitudes,
    getSolicitudesSnapshot,
    getSolicitudesServerSnapshot
  );

  return state;
}
